import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.48101 14.5159L11.9114 20.9968H12.7215L19 5.6047L18.3924 5L3 11.2755V12.0856L9.48101 14.5159Z"
        fill="var(--svg-color-main, black)"
      />
    </svg>
  )
}
